import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4" }
const _hoisted_2 = { class: "text-4xl" }
const _hoisted_3 = { class: "font-semibold flex items-center gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "pi pi-arrow-down"
}
const _hoisted_5 = { class: "flex flex-col items-center justify-center gap-2 md:flex-row" }
const _hoisted_6 = { class: "flex w-full items-center justify-between gap-2 md:w-auto md:justify-center" }
const _hoisted_7 = ["onClick"]

import { computed, onBeforeMount, ref } from "vue";
import { useStore } from "vuex";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import PosForm from "./PosForm.vue";
import { useI18n } from "vue-i18n";
import PConfirmDialog from "primevue/confirmdialog";
import { cloneDeep } from "lodash";
import { useNotify } from "@/composables/useNotify";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const activePos = ref<number>(-1);
const { t } = useI18n();
const { successToast, errorToast } = useNotify({ t });
const canShowEditButtonsOnPos = computed(() => {
  return activePos.value < 0;
});

const retrieveTenant = async () => {
  await store.dispatch("tenant/RETRIEVE", {
    tenantId: store.getters["user/info"]?.tenantId,
  });
};
onBeforeMount(async () => {
  await retrieveTenant();
});

const posList = computed<any[]>(
  () => cloneDeep(store.getters["tenant/info"])?.posList ?? []
);

const selectPos = (index: number) => {
  activePos.value = index;
};
const closeAll = () => {
  activePos.value = -1;
};

const updateAPos = async (pos: any) => {
  try {
    await store.dispatch("pos/UPDATE_POS", pos);
    closeAll();
    successToast({ title: t("pos"), detail: t("updatedSuccessfully") });

    await retrieveTenant();
  } catch (e: any) {
    errorToast({ title: t("pos"), error: e?.message });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_unref(PConfirmDialog)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("posList")), 1),
      _createVNode(_unref(Accordion), {
        activeIndex: activePos.value,
        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop","prevent"]))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(posList), (pos, posIndex) => {
            return (_openBlock(), _createBlock(_unref(AccordionTab), {
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"])),
              key: posIndex
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
                  class: "flex flex-col md:flex-row justify-between items-center w-full gap-y-2 p-5"
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(pos.name), 1),
                    (posIndex === activePos.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("i", {
                        class: _normalizeClass([{ invisible: !_unref(canShowEditButtonsOnPos) }, "pi pi-pencil hover:cursor-pointer"]),
                        onClick: ($event: any) => (selectPos(posIndex))
                      }, null, 10, _hoisted_7)
                    ])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(PosForm, {
                  "is-update": "",
                  pos: pos,
                  onCancel: _cache[1] || (_cache[1] = ($event: any) => (closeAll())),
                  onSave: updateAPos
                }, null, 8, ["pos"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ])
  ]))
}
}

})